import { GARSON_BRAND } from '@/components/brand/assets';

/** Decorative motion; the surrounding status owns the accessible label. */
export function LoadingDots() {
  return <span className="gs-loading-dots" aria-hidden="true"><i /><i /><i /></span>;
}

export function LoadingStatus({ label, chat = false }: { label: string; chat?: boolean }) {
  return (
    <div className={`gs-loading-status${chat ? ' gs-loading-status--chat' : ''}`} role="status" aria-live="polite">
      <LoadingDots />
      <span>{label}</span>
    </div>
  );
}

export function PageLoading({ label = 'داریم آماده می‌شیم…', branded = true }: { label?: string; branded?: boolean }) {
  return (
    <div className="gs-page-loading" role="status" aria-live="polite" dir="rtl">
      <div className="gs-loading-emblem" aria-hidden="true">
        <svg viewBox="0 0 96 96" fill="currentColor">
          <circle className="gs-loading-knob" cx="48" cy="15" r="6" />
          <path fillRule="evenodd" d="M12 64C14 42 29 26 48 26S82 42 84 64H12Zm9-7h8c3-12 10-20 21-26-15 1-26 11-29 26Z" />
          <path d="M9 69h78a4 4 0 0 1 0 8H73L58 89V77H9a4 4 0 0 1 0-8Z" />
        </svg>
      </div>
      {branded && <img className="gs-loading-wordmark" src={GARSON_BRAND.wordmark} alt="گارسون" width="110" height="40" />}
      <p>{label}</p>
      <span className="gs-loading-track" aria-hidden="true"><i /></span>
    </div>
  );
}
